// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_j3-0";